<template>
  <!-- scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-600 scrollbar-track-gray-900 dark:scrollbar-track-gray-800 dark:bg-gray-900 overflow-auto -->
  <aside v-show="!isFullScreen"
    class="w-64 h-screen fixed top-0 bg-white dark:bg-gray-900 transition-all sidebar-parent" :class="[
      !isAsideMobileExpanded ? 'sidebar-parent-open' : '',
      isAsideLgActive ? 'block' : 'lg:block',
    ]" style="transition: left 1s; z-index: 10">
    <!-- isAsideMobileExpanded ? '-left-64' : 'left-0', -->
    <div class="inner-sidebar">
      <div class="bg-top-sidebar transition-colors duration-1000" :class="darkMode ? 'bg-gray-400' : 'bg-white'">
        <div class="container-logo w-full h-auto">
          <!-- <show-image :imageName="schoolidentity.img" /> -->
          <img class="mx-auto h-10 w-auto" v-if="schoolidentity.img" :src="schoolidentity.img" alt="Status No Aktif" />
        </div>

        <div class="container-company w-full h-auto p-2 mt-4 transition-colors duration-1000"
          :class="darkMode ? 'bg-gray-400' : 'bg-sch-name'">
          <!-- <div
            v-if="dataSchoolList.length == 1"
            class="school-sidebar transition-colors duration-1000"
            :class="darkMode ? 'bg-darkmode-hard' : 'bg-white'"
          >
            <div class="name-sch">
              {{ schoolidentity.name }}
            </div>
          </div> -->
          <control v-if="schoolDataList.length >= 1" v-model="filter.school_id" :type="'select'"
            :options="schoolDataList" class="dark:border-gray-900 transition-colors duration-1000"
            style="margin-top: 10px; background-color: white !important" />

          <control v-if="branchListActive.length != 0" v-model="filter.branch_id" :type="'select'"
            :options="branchListActive" @change="reloadWeb()"
            class="dark:border-gray-900 transition-colors duration-1000"
            style="margin-top: 10px; background-color: white !important" />
        </div>
      </div>

      <div @click.prevent="menuToggleMobile" class="button-close-aside"
        :class="{ 'button-show-aside': isAsideMobileExpanded }">
        <icon :path="mdiBackburger" :w="'w-6'" :h="'h-6'" />
      </div>

      <div class="menu-sidebar transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-hard' : 'bg-white'">
        <div style="padding: 0 8px 20px 8px">
          <control v-model="searchQuery" :type="'text'" :placeholder="'Search menu...'" />
        </div>

        <template v-for="data in filteredMenus" :key="data">
          <AsideMenuList :menu="data" />
        </template>
      </div>
    </div>
  </aside>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { computed, ref, onMounted, reactive, watch, watchEffect } from "vue";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { mdiMenu, mdiForwardburger, mdiBackburger } from "@mdi/js";
import AsideMenuList from "@/components/AsideMenuList";
import Control from "@/components/Control";
import Icon from "@/components/Icon";
import { useBranchManager } from "@/composables/useBranchManager";
import {
  getCheckRoleUser
} from "@/composables/global";


export default {
  name: "AsideMenu",
  components: {
    AsideMenuList,
    Control,
    Icon,
  },
  props: {
    menu: { type: Array, default: () => [] },
  },
  setup(props, { emit }) {
    const store = useStore();
    const toast = useToast();
    const {
      schoolDataList,
      branchDataList,
      schoolDefaultId,
      branchDefaultId,
    } = getCheckRoleUser({
      id: localStorage.getItem("user_id") ?? "",
    });

    const searchQuery = ref("");
    const filteredMenus = computed(() => {
      if (!searchQuery.value) return props.menu;

      const query = searchQuery.value.toLowerCase();

      return props.menu
        .map((item) => {
          const isMatch = item.label.toLowerCase().includes(query);

          const filteredSubmenu = item.menu
            ? item.menu.filter((sub) => sub.label.toLowerCase().includes(query))
            : [];

          if (isMatch) {
            return { ...item };
          }

          if (filteredSubmenu.length) {
            return { ...item, menu: filteredSubmenu };
          }

          return null;
        })
        .filter(Boolean);
    });

    const isFullScreen = computed(() => store.state.isFullScreen);
    const isAsideMobileExpanded = computed(
      () => store.state.isAsideMobileExpanded
    );
    const isAsideLgActive = computed(() => store.state.isAsideLgActive);
    const menuToggleMobile = () => store.dispatch("asideMobileToggle");

    const branchData = ref(branchDataList);

    const branchListActive = computed(() => {
      return branchData.value.filter(
        item => String(item.school_id) === String(filter.school_id)
      );
    });

    const filter = reactive({
      school_id: '',
      branch_id: '',
    });

    const schoolidentity = reactive({
      id: "",
      name: "",
      website_url: "",
      email: "",
      address1: "",
      address2: "",
      address3: "",
      address4: "",
      telp1: "",
      telp2: "",
      telp3: "",
      telp4: "",
      fax1: "",
      fax2: "",
      description: "",
      file_name: "",
      status: "",
      library: "",
      info1: "",
      info2: "",
      info3: "",
      created_by: "",
      updated_by: "",
    });

    const getData = async () => {
      try {
        const { data } = await axios.get("/get-menu");
        Object.assign(schoolidentity, data.data);
      } catch (error) {
        console.error(error);
      }
    };

    onMounted(() => {
      getData();
    });

    const reloadWeb = () => {
      window.location.reload();
    };

    const darkMode = computed(() => store.state.darkMode);
    const storedSchoolId = localStorage.getItem("school_id");
    const storedBranchId = localStorage.getItem("branch_id");

    onMounted(() => {
      if (storedSchoolId) {
        filter.school_id = storedSchoolId;
      } else {
        filter.school_id = schoolDefaultId;
      }

      if (storedBranchId) {
        filter.branch_id = storedBranchId;
      } else {
        filter.branch_id = branchDefaultId;
      }
    });

    watch(
      () => filter.school_id,
      (newSch, oldSch) => {
        if (!newSch || newSch === oldSch) return;
        // Save selected school
        localStorage.setItem("school_id", newSch);
        // Find first branch of selected school
        // const firstBranch = props.dataBranchList.find(
        //   item => item.school_id === newSch
        // );

        // if (firstBranch) {
        //   filter.branch_id = firstBranch.id;
        //   localStorage.setItem("branch_id", firstBranch.id);
        // }
      }
    );

    watch(
      () => filter.branch_id,
      (newBranch, oldBranch) => {
        if (newBranch && newBranch !== oldBranch) {
          localStorage.setItem("branch_id", newBranch);
        }
      }
    );
    
    return {
      reloadWeb,
      filter,
      darkMode,
      isFullScreen,
      isAsideMobileExpanded,
      menuToggleMobile,
      isAsideLgActive,
      mdiMenu,
      mdiForwardburger,
      mdiBackburger,
      schoolidentity,
      searchQuery,
      filteredMenus,
      branchListActive,
      schoolDataList,
      branchDataList,
      schoolDefaultId,
      branchDefaultId,
    };
  },
};
</script>
